import React from 'react';
export const GuaranteeSection = () => {
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-101">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-102">
        <div className="bg-familia-card border-2 border-familia-gold p-8 md:p-16 rounded-[2rem] md:rounded-[2.5rem] text-center relative overflow-hidden" data-id="element-103">
          <div className="text-5xl md:text-7xl mb-6 md:mb-10" data-id="element-104">🛡️</div>
          <h2 className="text-[22px] sm:text-2xl md:text-4xl font-display font-bold mb-6 md:mb-8 uppercase tracking-wider" data-id="element-105">
            GARANTÍA VITALIDAD 360 — 7 DÍAS
          </h2>
          <div className="space-y-1 md:space-y-2 mb-6 md:mb-10 text-lg sm:text-xl md:text-2xl font-bold" data-id="element-106">
            <p data-id="element-107">Abrís el Master Kit.</p>
            <p data-id="element-108">Hacés las primeras actividades con tu ser querido.</p>
            <p data-id="element-109">Usás la Bitácora de Control para el médico.</p>
            <p data-id="element-110">Aplicás el Módulo vip +150 ejercicios con tu nivel.</p>
          </div>
          <div className="text-familia-gray text-[15px] md:text-xl leading-relaxed mb-6 md:mb-10 max-w-xl mx-auto" data-id="element-111">
            <p data-id="element-112">
              Si en 7 días no es exactamente lo que esperabas, te devolvemos el
              100%.
            </p>
            <p className="text-white font-bold mt-3 md:mt-4" data-id="element-113">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>
          <p className="text-familia-cyan text-[13px] md:text-sm font-medium mb-6 md:mb-10" data-id="element-114">
            La confianza que tenemos en el sistema nos permite hacer esa promesa
            sin dudarlo un segundo.
          </p>
          <div className="inline-block bg-familia-green text-familia-bg font-bold px-5 md:px-6 py-2 rounded-full text-xs md:text-sm" data-id="element-115">
            Tasa de devolución menor al 2%
          </div>
        </div>
      </div>
    </section>;
};